module.exports = __webpack_public_path__ + "static/img/main_pop.6fe1154.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/main_pop.jpg
// module id = ssmB
// module chunks = 1